import { useMemo } from "react";
import { HYPHEN } from "@/config";
import { ClientFormsQuery } from "@/graphql/queries/client/clientForms.graphql.types";
import { ClientByTokenQuery } from "@/graphql/queries/clientByToken.graphql.types";

export const NO_FORM_PLACEHOLDER = "[Deleted form]";

type FormSubmission =
  | ClientByTokenQuery["clientAccessTokenByPk"]["client"]["formSubmissions"][number]
  | ClientFormsQuery["clientByPk"]["formSubmissions"][number];

type SubmissionVersion = {
  id: string;
  name: string;
  submittedAt: string;
  url: string;
};

export default function useFormSubmissionVersionsList(
  formSubmission: FormSubmission,
  baseUrl: string,
  backUrl?: string
): SubmissionVersion[] {
  return useMemo(() => {
    const { id, versions, submittedAt, form } = formSubmission;

    if (!versions || versions.length === 0) {
      const backUrlParam = backUrl ? `?backUrl=${backUrl}` : "";
      return [
        {
          id: id,
          name: form?.title || NO_FORM_PLACEHOLDER,
          submittedAt,
          url: `${baseUrl}/${id}${backUrlParam}`,
        },
      ];
    }

    const backUrlParam = backUrl ? `&backUrl=${backUrl}` : "";
    return versions.map(({ id: versionId, created, version }) => ({
      id: versionId,
      name: `${form?.title || NO_FORM_PLACEHOLDER} ${HYPHEN} v${version}`,
      submittedAt: created,
      url: `${baseUrl}/${id}?version=${version}${backUrlParam}`,
    }));
  }, [formSubmission, backUrl, baseUrl]);
}
